import React from 'react'
import refund from '../images/Refund-and-cancellations.png'
import { Helmet } from 'react-helmet'
function RefundCancellation() {
    return (
        <div>
            <Helmet>
                <title>Parcelx - Refund & Cancellation</title>
            </Helmet>
            <section className='section01 pb-0 trmsss'>
                <div className='container-fluid'>
                    <div className='col-md-11 mx-auto'>
                        <div className="row align-items-center">
                        <div className="col-md-6 order-md-2 text-md-end">
                            <img src={refund} height="350" alt="" />
                        </div>
                        <div className="col-lg-6">
                            <h1 className="display-3">Refund & Cancellation Policy</h1>
                        </div>
                    </div>
                    </div>
                </div>
            </section>
            <section className='section01 pb-0 trmsss'>
                <div className='container-fluid'>
                    <div className='col-md-11 mx-auto'>
                        <h5>Account Deactivation Policy</h5>
                        <div className="Policy">
                            <ul>
                                <li>For Account Deactivation, contact your concerned POC.</li>
                                <li>The request for account deactivation will be processed after the closure of all your shipments.</li>
                                <li>Once your deactivation request is completed your wallet balance will be transferred to your bank account.</li>
                            </ul>
                        </div>
                        <h5>Refund Policy</h5>
                        <h6>For not picked shipments-</h6>
                        <div className="Policy">
                            <ul>
                                <li>you can cancel the order, and a refund will be credited immediately to your wallet.</li>
                            </ul>
                        </div>
                        <h6>For insured shipments- </h6>
                        <div className="Policy">
                            <ul>
                                <li>you will get up to 98% of the invoice value for lost shipments.</li>
                                <li>For damaged shipments, it is mandatory to share packaging and unboxing videos to process the claim.</li>
                            </ul>
                        </div>
                        <h6>For non-insured shipments- </h6>
                        <div className="Policy">
                            <ul>
                                <li>we will issue a COF (Certificate of Fact) or refund to the extent of the lost liability clause.</li>
                                <li>for damaged shipments, it is mandatory to share packaging and unboxing videos, we will issue a COF (Certificate of Fact) or refund to the extent of the lost liability clause.</li>
                            </ul>
                            </div>
                            <p>The refund amount will be credited either to your wallet or bank account as per your request.</p>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default RefundCancellation
